
<div class="add-cards">
  <page-header title="Verify Cards">
    <template #actions>
      <align small-gap>
        <icon-button
          v-if="isAdmin && selectedCardIds.length > 0 && status !== 'active'"
          icon="cloud_upload"
          tooltip="Admit selected cards"
          :loading="admitting"
          @click="admitCards"
        />

        <template v-if="showActions">
          <icon-button
            v-if=" status !== 'active'"
            icon="drive_file_move"
            :tooltip="`Move selected cards ${status === 'review' ? 'back to in progress' : 'into ready for review'}`"
            :loading="moving"
            @click="moveCards"
          />

          <icon-button
            v-if=" status !== 'active'"
            icon="move_to_inbox"
            tooltip="Rescrape sales for selected cards"
            :loading="scraping"
            @click="scrapeSales"
          />

          <icon-button
            icon="refresh"
            tooltip="Refresh stats for selected cards"
            :loading="refreshing"
            @click="refreshStats"
          />

          <icon-button
            v-if="isAdmin"
            icon="delete"
            tooltip="Delete selected cards"
            :loading="deleting"
            @click="deleteCards"
          />
        </template>

        <icon-button
          icon="add_circle"
          tooltip="Add New Card"
          @click="addCard"
        />
      </align>
    </template>
  </page-header>

  <align flex collapse-end direction="flex-start">
    <shared-filters
      show-recent-searches
      :filters.sync="filters"
      :query.sync="query"
      :properties="defaultFilters"
      @clear="clearFilters"
    />

    <align small-gap>
      <pill-dropdown
        v-model="employee"
        :options="employeeFilterOptions"
      />

      <pill-dropdown
        v-model="status"
        :options="statusOptions"
      />

      <direction-sort-options
        :sort.sync="sort"
        :direction.sync="direction"
        :options="sortOptions"
      />
    </align>
  </align>

  <filter-results
    is-filtering
    :filters="filters"
    :results="numResults"
    @clear="clearFilters"
  />

  <div class="results">
    <empty-state
      v-if="showEmptyState"
      icon="rowing"
      title="You are all caught up!"
    />

    <template>
      <div class="list">
        <align v-show="cards.length" class="select-all">
          <icon-button
            :class="{ success: selectedCardIds.length === cards.length }"
            :icon="selectAllIcon"
            @click="toggleSelectAll"
          />

          <div><strong>{{ selectedCardIds.length }}</strong> selected</div>
        </align>

        <card-list-item
          v-for="card in cards"
          :key="card.id"
          as="router-link"
          :to="{ query: { ...$route.query, cardId: card.id } }"
          :card="card"
          :fields="itemFields"
          selectable
          :selected="selectedCardIds.includes(card.id)"
          @toggleSelected="toggleSelectedCard(card.id)"
        />
      </div>

      <infinite-scroll
        :loading="loading"
        :has-more-data="hasMoreData"
        @load="nextPage"
      />
    </template>
  </div>

  <scroll-top />
</div>
